import sanitizeHtml from 'sanitize-html'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import AllYourEventsCentralizedImage from './AllYourEventsCentralizedImage'

const copy = {
  heading: `All your events centralized`,
  description: `Easily collect events in your warehouse. With <a href="https://segment.com/docs/connections/storage/">Segment Storage Destinations</a> your event data is schematized for easy querying across all your event properties`,
}

const AllYourEventsCentralized = () => {
  return (
    <SectionBase variant="2Col" copyVariant="narrow">
      <Section.Copy alignSelf="center">
        <CopyTextBase>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <CopyText.Description
            tag="p"
            variant="pLarge"
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(copy.description, { allowedTags: [`a`] }),
            }}
          />
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <AllYourEventsCentralizedImage />
      </Section.Contents>
    </SectionBase>
  )
}

export default AllYourEventsCentralized
